import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { fieldsMap } from '../fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	fieldsMap.get('files'),
	fieldsMap.get('lang'),
	fieldsMap.get('duration_in_seconds')
];

const config: IFormConfig = { 
	fields: formFields 
};

export default config;
